import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import ProductDetails from "../Components/ProductDetails";

const DetailsPage = () => {
  return (
    <div>
      <Header />
      <ProductDetails />
      <Footer />
    </div>
  );
};

export default DetailsPage;
